import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
export function SnackBarAlertComponent(param) {
    let { open, onClose, message, alertColor } = param;
    const toastIdRef = useRef(null);
    useEffect(()=>{
        if (open && message) {
            const showToast = ()=>{
                switch(alertColor){
                    case 'success':
                        toastIdRef.current = toast.success(message, {
                            duration: 6000
                        });
                        break;
                    case 'error':
                        toastIdRef.current = toast.error(message, {
                            duration: 6000
                        });
                        break;
                    case 'info':
                        toastIdRef.current = toast.info(message, {
                            duration: 6000
                        });
                        break;
                    case 'warning':
                        toastIdRef.current = toast.warning(message, {
                            duration: 6000
                        });
                        break;
                    default:
                        toastIdRef.current = toast.error(message, {
                            duration: 6000
                        });
                }
            };
            showToast();
        } else if (!open && toastIdRef.current !== null) {
            toast.dismiss(toastIdRef.current);
            toastIdRef.current = null;
            onClose();
        }
    }, [
        open,
        message,
        alertColor,
        onClose
    ]);
    // Return null since Sonner handles rendering
    return null;
}
